import { useEffect, useState } from "react";

const KEY = "gadopro:font-scale";

// Escala aplicada na fonte raiz — todo o app (rem-based) se adapta proporcionalmente
export const FONT_SCALES = [
  { id: "normal", label: "Normal", pct: 100, hint: "A" },
  { id: "grande", label: "Grande", pct: 112.5, hint: "A+" },
  { id: "extra", label: "Extra", pct: 125, hint: "A++" },
];

function resolve(id) {
  return FONT_SCALES.find((s) => s.id === id) || FONT_SCALES[0];
}

function apply(id) {
  const scale = resolve(id);
  document.documentElement.style.fontSize = `${(16 * scale.pct) / 100}px`;
}

export function useFontScale() {
  const [scale, setScale] = useState(() => {
    if (typeof window === "undefined") return "normal";
    return localStorage.getItem(KEY) || "normal";
  });

  useEffect(() => {
    apply(scale);
  }, [scale]);

  const setFontScale = (v) => {
    const valid = resolve(v).id;
    setScale(valid);
    if (typeof window !== "undefined") localStorage.setItem(KEY, valid);
  };

  return { scale, setFontScale, scales: FONT_SCALES };
}

// Inicializa antes do React montar para evitar flash com a fonte padrão
export function bootstrapFontScale() {
  try {
    apply(localStorage.getItem(KEY) || "normal");
  } catch {
    /* ignore */
  }
}
